// Themed "Your Fit" cards, per product. Each card links to 2–3 turntable
// hotspots (pin steps resolved by FitHotspots for the shopper's own body). The
// card themes reflect what THAT category of bra is designed for. MI10 (217) is a
// sports bra; features are verified against the PDP (Wirefree & Padded · Full
// Coverage · Front Zipper · StayDry · Broad Underband · Microfiber · Label-free ·
// active racerback — the straps are NOT adjustable, so there is no straps pin).

// Pin steps — feature/sub/angle map to anchors every MI10 body carries.
const P = {
  cup:      { feature: "cups", sub: "apex", angle: 0, tag: "Padded cup", note: "Wirefree padded cup shapes and holds you." },
  coverage: { feature: "cups", sub: "coverage", angle: 0, tag: "Full coverage", note: "Sits high on the chest — no gaping." },
  band:     { feature: "underband", sub: "center", angle: 0, tag: "Broad underband", note: "Wide band carries the support." },
  zip:      { feature: "cups", sub: "center", angle: 0, tag: "Front zip", note: "Quick, secure front zip — easy on & off." },
  back:     { feature: "edge", sub: "center", angle: 180, tag: "Racerback", note: "Active racerback moves with you." },
  bandEdge: { feature: "underband", sub: "lower", angle: 0, tag: "Soft edge", note: "Wirefree — soft, even pressure, no dig." },
};
const MI10_OVERVIEW = [P.cup, P.coverage, P.band, P.zip, P.back]; // 5 prime hotspots

// 1820 (210) — Fragrant Lily "Wirefree Non-Padded Soft Touch Full Coverage
// Everyday bra with Stylised Mesh Panel". Features verified against the PDP:
// Wirefree & Non-Padded · Full Coverage · Stylised Front Mesh Panel · Plush
// Lining / Cotton-Lined Cups (No Apex Show) · Broad Cushioned adjustable Straps ·
// Soft-Touch Microfiber. Anchors from fitFeatures.1820.json (measured on-frame).
const P1820 = {
  coverage: { feature: "cups",      sub: "coverage", angle: 0,   tag: "Full coverage",    note: "Sits high on the chest — full coverage, no gaping." },
  cup:      { feature: "cups",      sub: "apex",     angle: 0,   tag: "Cotton-lined cup", note: "Soft cotton-lined cup — shapes you with no apex show-through." },
  mesh:     { feature: "cups",      sub: "center",   angle: 0,   tag: "Mesh front panel", note: "Stylised front mesh panel — breathable, keeps its shape." },
  strap:    { feature: "cups",      sub: "strap",    angle: 0,   tag: "Cushioned straps",  note: "Broad cushioned, adjustable straps — no shoulder dig.", place: "right" },
  band:     { feature: "underband", sub: "center",   angle: 0,   tag: "Broad wirefree band", note: "Wide wirefree band spreads support evenly — no wire." },
  back:     { feature: "edge",      sub: "center",   angle: 180, tag: "Adjustable back",   note: "Hook-and-eye back adjusts the band as you wear it in." },
};
const F1820_OVERVIEW = [P1820.coverage, P1820.cup, P1820.mesh, P1820.strap, P1820.band, P1820.back];

// 1841 (212) — Deep Taupe MINIMISER bra. Features from the PDP: Minimiser
// (visually reduces the bust by ~1") · Soft-Touch Microfiber · Broad Cushioned
// Straps · Side Reinforcement (hold + smoothing) · Full Coverage. Anchors come
// from fitFeatures.1841.json (real, pipeline-generated).
const P1841 = {
  coverage: { feature: "cups",      sub: "coverage", angle: 0,   tag: "Full coverage",    note: "Full coverage smooths the bustline — no spillage." },
  cup:      { feature: "cups",      sub: "apex",     angle: 0,   tag: "Minimiser cup",    note: "Minimiser cup visually reduces the bust by up to 1 inch." },
  strap:    { feature: "cups",      sub: "strap",    angle: 0,   tag: "Cushioned straps",  note: "Broad cushioned straps — all-day shoulder comfort.", place: "right" },
  band:     { feature: "underband", sub: "center",   angle: 0,   tag: "Broad underband",   note: "Wide band with side reinforcement — steady hold and smoothing." },
  back:     { feature: "edge",      sub: "center",   angle: 180, tag: "Smooth back",       note: "Smooths across the back — no band bulge." },
};
const F1841_OVERVIEW = [P1841.coverage, P1841.cup, P1841.strap, P1841.band, P1841.back];

// MI16 (216) — Grape Wine "Wirefree Padded Soft Touch Microfiber Full Coverage
// Racerback Sports Bra with StayDry Treatment". Features from the PDP: Wirefree &
// Padded · Full Coverage · Broad Underband (extra support) · Racerback Styling ·
// StayDry (moisture-wicking) + StayFresh (anti-microbial) · Soft-Touch Microfiber ·
// adjustable cushioned straps · Label Free. MI16 shares the Round_D34 body grid
// with 1820, so the anchors come from fitFeatures.MI16.json (same body, MI16 labels).
const PMI16 = {
  coverage: { feature: "cups",      sub: "coverage", angle: 0,   tag: "Full coverage",     note: "High square neckline — full coverage, no spill during movement." },
  cup:      { feature: "cups",      sub: "apex",     angle: 0,   tag: "Padded cup",        note: "Wirefree padded cup gently shapes and holds — no wire to dig in." },
  fabric:   { feature: "cups",      sub: "center",   angle: 0,   tag: "StayDry fabric",    note: "Soft-touch microfiber — StayDry wicks sweat, StayFresh stays odour-free." },
  strap:    { feature: "cups",      sub: "strap",    angle: 0,   tag: "Adjustable straps", note: "Adjustable cushioned straps — set your own fit, no shoulder dig.", place: "right" },
  band:     { feature: "underband", sub: "center",   angle: 0,   tag: "Broad underband",   note: "Broad underband anchors the support for mid–high impact." },
  back:     { feature: "edge",      sub: "center",   angle: 180, tag: "Racerback",         note: "Racerback moves with you — full shoulder mobility, stays put." },
};
const FMI16_OVERVIEW = [PMI16.coverage, PMI16.cup, PMI16.fabric, PMI16.strap, PMI16.band, PMI16.back];

const CUP_IDX = { A: 0, B: 0, C: 1, D: 2, DD: 3 };

// Activity verdicts scale with cup size (wirefree padded = moderate–high impact).
// Max 4 activities so the card never overflows.
function mi10Activities(ci) {
  return [
    { e: "🧘", label: "Yoga", v: "yes" },
    { e: "🏃", label: "Running", v: ci <= 1 ? "yes" : "ok" },
    { e: "🔥", label: "HIIT", v: ci <= 1 ? "yes" : ci === 2 ? "ok" : "no" },
    { e: "🎾", label: "Tennis", v: "no" },
  ];
}

function mi10Model(shape, cup) {
  const ci = CUP_IDX[cup] ?? 1;
  const acts = mi10Activities(ci);
  const coverChips =
    shape === "round" ? ["Full coverage", "Sits high", "No gaping"]
    : shape === "teardrop" ? ["Covers bottom", "Room up top", "No spill"]
    : shape === "bell" ? ["Broad cover", "Fills top edge", "No gape"]
    : ["Full coverage", "Even fit", "No gaping"]; // eastwest
  const supportChips = ci >= 2 ? ["Medium–high", "True-to-size band"] : ["Medium–high", "Bounce control"];
  return {
    overview: MI10_OVERVIEW,
    bestFor: acts.filter((a) => a.v === "yes").map((a) => `${a.e} ${a.label}`),
    cards: [
      { id: "madefor", emoji: "🏃", title: "Made for", short: "Made for", kind: "acts", chips: acts, seq: [P.band, P.cup, P.back] },
      { id: "support", emoji: "💪", title: "Support & bounce", short: "Support", kind: "chips", chips: supportChips, seq: [P.band, P.cup] },
      { id: "coverage", emoji: "🎯", title: "Coverage & shape", short: "Coverage", kind: "chips", chips: coverChips, seq: [P.coverage, P.cup] },
      { id: "comfy", emoji: "😎", title: "Cool & comfy", short: "Comfy", kind: "chips", chips: ["Wirefree", "💦 StayDry", "🤐 Easy zip"], seq: [P.bandEdge, P.zip] },
    ],
  };
}

// Product id → card model. Only configured products get the card UI; the rest
// fall back to the chat. MI10 (217) now uses the CHAT (which is linked to the
// turntable hotspots), so no product is on the card UI — leave THEMES empty.
const THEMES = {}; // (mi10Model kept above for reference / future reuse)
// eslint-disable-next-line no-unused-vars
const _mi10ModelRef = mi10Model;

export function fitCardsModel(productId, opts = {}) {
  const fn = THEMES[String(productId)];
  return fn ? fn(opts.shape, opts.cup) : null;
}

// Hotspots to auto-play on the OTHER fit tabs, so the turntable stays alive while
// the shopper works through their shape and size. "bust" → the cup + coverage
// (what their bust shape drives); "size" → the underband + cup (band + cup).
// Returns null for products without hotspots.
const TAB_HOTSPOTS = {
  // All fit screens show the FULL set of body hotspots at once (the shopper can
  // tap any, or a chat answer triggers one). Same overview on bust/size/fit.
  "210": {
    bust: F1820_OVERVIEW,
    size: F1820_OVERVIEW,
    fit:  F1820_OVERVIEW,
  },
  "212": {
    bust: F1841_OVERVIEW,
    size: F1841_OVERVIEW,
    fit:  F1841_OVERVIEW,
  },
  "217": {
    bust: MI10_OVERVIEW,
    size: MI10_OVERVIEW,
    fit:  MI10_OVERVIEW,
  },
  "216": {
    bust: FMI16_OVERVIEW,
    size: FMI16_OVERVIEW,
    fit:  FMI16_OVERVIEW,
  },
};
export function fitTabHotspots(productId, tab) {
  const conf = TAB_HOTSPOTS[String(productId)];
  const seq = conf && conf[tab];
  return seq ? seq.map((s) => ({ ...s })) : null;
}

// Hero hotspots for products that run hotspots on the MAIN turntable (not just
// the Your Fit card). Keyed by the turntable frame-set prefix that RenderTurntable
// carries (e.g. "MI10"). MI10 shows its 5-feature overview by default.
const HERO_HOTSPOTS = { MI10: MI10_OVERVIEW, "1820": F1820_OVERVIEW, "1841": F1841_OVERVIEW, MI16: FMI16_OVERVIEW };
export function heroHotspots(prefix) {
  const seq = HERO_HOTSPOTS[String(prefix)];
  return seq ? seq.map((s) => ({ ...s })) : null;
}
